function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

import utils from './utils';
var isPlainObject = utils.isPlainObject,
    extend = utils.extend,
    trim = utils.trim,
    parseJSON = utils.parseJSON,
    throwError = utils.throwError,
    add_url_query = utils.add_url_query;
var requestInfo = {};
/**
 * ajax响应处理方法
 */

function ajaxResponse() {
  var handler = arguments[0];
  var args = [];

  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
  }

  var ajaxType = this.type + this.url;

  if (requestInfo[ajaxType]) {
    requestInfo[ajaxType].loading = false;
    requestInfo[ajaxType].endDate = new Date();
    requestInfo[ajaxType].time = Number(requestInfo[ajaxType].endDate) - Number(requestInfo[ajaxType].startDate || new Date());
  }

  if (handler === 'error') {
    console.error('ajax error:', args, this);

    if (requestInfo[ajaxType]) {
      requestInfo[ajaxType].error = args[1] || handler;
    }
  }

  typeof this.options[handler] === "function" && this.options[handler].apply(this, args);
  typeof this.options.complete === "function" && this.options.complete.apply(this, args);
}
/**
 * ajax 数据转换
 * @param {string} text 
 * @param {string} type 
 */


function ajaxConvert(text, type) {
  switch (type) {
    case 'json':
      return parseJSON(text);

    default:
      return text;
  }
}
/**
 * traditionalData
 * @param {object} data 
 * @param {string} key 
 * @param {array} arr 
 */


function traditionalData(data, key, arr) {
  for (var index = 0; index < arr.length; index++) {
    var value = arr[index];

    if (_typeof(value) === 'object' && value !== null) {
      value = JSON.stringify(value);
    }

    data.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  }

  return data;
}
/**
 * 处理请求头
 * @param {object} headers 
 */


function parseRequestHeaders(headers) {
  if (!isPlainObject(headers)) {
    return {};
  }

  var _headers = {};

  for (var key in headers) {
    if (headers.hasOwnProperty(key)) {
      if (typeof headers[key] !== 'string' && typeof headers[key] !== 'number') {
        continue;
      }

      var _key = key.toLowerCase();

      _headers[_key] = headers[key];
    }
  }

  return _headers;
}
/**
 * 支持的方法
 */


var methods = ['GET', 'POST', 'HEAD', 'PUT', 'DELETE', 'OPTIONS'];
var fakeMethods = ['PUT', 'DELETE', 'OPTIONS'];
var jsonpCount = 0;

function removeScript(parent, script) {
  try {
    parent && script && parent.removeChild(script);
  } catch (error) {}
}
/**
 * 检查是否支持同时多请求
 * @param {*} type 
 * @param {*} url 
 * @param {*} jsonp 
 */


function allowMultiRequest(params, type, url) {
  if (!params.allowMultiRequest && !params.allowMultiReqest) {
    // 默认不支持同URL，同时多个同类型请求
    var requestType = type + url;

    if (!requestInfo[requestType]) {
      requestInfo[requestType] = {};
    }

    if (requestInfo[requestType].loading === true) {
      console.warn('do not support multi-request by the same url and type, at the same time.\nyou can add `allowMultiRequest` param to support it');
      return false;
    }

    requestInfo[requestType].startDate = new Date();
    requestInfo[requestType].loading = true;
  }

  return true;
}
/**
 * ajax方法
 * @param {string} _url 
 * @param {object|string} params 
 */


function ajax(_url, params) {
  if (_typeof(_url) == "object") {
    params = _url;
    _url = params.url;
  }

  var type = 'GET',
      async = true,
      paramstring = '',
      timeout = 0,
      url = trim((_url || '/').replace(/(#.+)?/i, '')),
      contentType = "application/x-www-form-urlencoded",
      sendData = null,
      queryString = '';

  if (_typeof(params) !== "object") {
    params = {
      headers: {}
    };
  }

  var isFormData = window.FormData && params.data instanceof window.FormData; // 请求头参数过滤

  var requestHeaders = parseRequestHeaders(window.AjaxRequestHeaders || ajax.requestHeaders || {});
  params.headers = parseRequestHeaders(_typeof(params.headers) === 'object' && params.headers !== null ? params.headers : {});
  params.headers['content-type'] = params.headers['content-type'] || params.contentType || contentType;

  if (params.contentType === false || isFormData) {
    delete params.headers['content-type'];
  }

  contentType = params.headers['content-type'] || '';

  if (params.timeout && params.timeout > 0) {
    timeout = params.timeout;
  } // 判断请求类型


  if (typeof params.type == "string" && methods.indexOf(params.type.toUpperCase()) > -1) {
    type = params.type.toUpperCase();
  }

  if (typeof params.method == "string" && methods.indexOf(params.method.toUpperCase()) > -1) {
    type = params.method.toUpperCase();
  }

  if (typeof params.headers.method == 'string' && methods.indexOf(params.headers.method.toUpperCase()) > -1) {
    type = params.headers.method.toUpperCase();
  }

  if (isFormData) {
    type = 'POST';
  } // 响应数据类型


  params.dataType = params.dataType || 'json'; // 是否异步请求默认true

  if (typeof params.async === "boolean") {
    async = params.async;
  }

  var traditional = []; // 数据处理

  if (params.processData !== false && !isFormData) {
    // 处理发送的数据
    if (_typeof(params.data) === "object" && params.data !== null) {
      if (contentType === 'application/json') {
        paramstring = JSON.stringify(params.data);
      } else {
        var data = [];

        for (var key in params.data) {
          if (_typeof(params.data[key]) === "object" && params.data[key] !== null) {
            if (params.data[key] instanceof Array && params.traditional === true) {
              traditionalData(traditional, key, params.data[key]);
            } else {
              params.data[key] = JSON.stringify(params.data[key]);
              data.push(encodeURIComponent(key) + '=' + encodeURIComponent(params.data[key]));
            }
          } else {
            data.push(encodeURIComponent(key) + '=' + encodeURIComponent(params.data[key]));
          }
        }

        paramstring = queryString = data.join('&');
      }
    } else {
      paramstring = params.data + '';
    }

    if (contentType === 'application/x-www-form-urlencoded' && paramstring) {
      paramstring = paramstring.replace(/%20/g, '+');
    }

    sendData = paramstring.length ? paramstring : null;
  } else {
    sendData = params.data;
  }

  var isJSONP = params.dataType.toUpperCase() === "JSONP";

  if (isJSONP) {
    type = 'GET';
  }

  if (type === "GET" || type === 'HEAD') {
    url = add_url_query(url, queryString);
    sendData = null;
  }

  if (traditional && traditional.length) {
    url = add_url_query(url, traditional.join('&'));
  }

  var _type = type; // 伪造请求类型, 不支持jsonp

  var fakeMethod = typeof window.AjaxFakeMethod === 'boolean' ? window.AjaxFakeMethod : window.AjaxFakeMethod || ajax.fakeMethod;

  if (!isJSONP && fakeMethod && fakeMethods.indexOf(type.toUpperCase()) > -1) {
    url = add_url_query(url, typeof fakeMethod === 'string' ? fakeMethod : '_method', type);
    type = 'POST';
  }

  var xhrData = {
    url: url,
    jsonp: isJSONP,
    type: type,
    options: params
  };
  var xmlhttp;

  if (!allowMultiRequest(params, type, url)) {
    return xhrData;
  }

  if (!isJSONP) {
    if (window.XMLHttpRequest) {
      // code for all new browsers
      xmlhttp = new XMLHttpRequest();
    } else if (window.ActiveXObject) {
      // code for IE5 and IE6
      xmlhttp = new window.ActiveXObject("Microsoft.XMLHTTP");
    }

    if (!xmlhttp) {
      return throwError("Your browser does not support XMLHTTP.");
    }

    xmlhttp.open(type, url, async);

    if (async) {
      // 异步方法
      // 设置超时
      xmlhttp.timeout = timeout || 0; // 超时回调

      xmlhttp.ontimeout = function (event) {
        ajaxResponse.call(xhrData, 'error', 'timeout', event);
      }; // 取消回调


      xmlhttp.onabort = function (event) {
        ajaxResponse.call(xhrData, 'error', 'abort', event);
      };
    } // 出错回调


    xmlhttp.onerror = function (event) {
      ajaxResponse.call(xhrData, 'error', 'error', event);
    };

    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState === 4) {
        var convertData = ajaxConvert(xmlhttp.responseText, params.dataType);
        var isSuccess = xmlhttp.status >= 200 && (xmlhttp.status < 300 || xmlhttp.status === 304);

        if (isSuccess) {
          ajaxResponse.call(xhrData, 'success', convertData);
        } else {
          ajaxResponse.call(xhrData, 'error', xmlhttp.status, convertData);
        }
      }
    };

    params.headers["X-Requested-With"] = "XMLHttpRequest";

    if (params.method_header_key !== false) {
      params.headers[typeof params.method_header_key === 'string' ? params.method_header_key : 'ajax_method'] = _type;
    } // 设置请求头


    for (var _key2 in requestHeaders) {
      // 全局定义的
      if (Object.hasOwnProperty.call(requestHeaders, _key2)) {
        xmlhttp.setRequestHeader(_key2, requestHeaders[_key2]);
      }
    }

    for (var _key3 in params.headers) {
      // 本次请求
      if (Object.hasOwnProperty.call(params.headers, _key3)) {
        xmlhttp.setRequestHeader(_key3, params.headers[_key3]);
      }
    }

    if (typeof params.beforeSend == "function" && params.beforeSend.call(xhrData, xmlhttp, sendData) === false) {
      return xmlhttp.abort();
    }

    try {
      xmlhttp.send(sendData);
    } catch (error) {
      ajaxResponse.call(xhrData, 'error', 'error', error);
    }
  } else {
    var timeoutTimer;
    var callbackFunction = params.jsonpCallback || 'jsonp' + ++jsonpCount + new Date().getTime();
    var jsonp = params.jsonp || 'callback';
    url = add_url_query(url, jsonp, callbackFunction);
    var script = document.createElement('script');
    var head = document.getElementsByTagName('head')[0];
    script.type = 'text/javascript';

    var scriptAbort = function scriptAbort(event) {
      clearTimeout(timeoutTimer);
      removeScript(head, script);
      ajaxResponse.call(xhrData, 'error', 'abort', event);
    };

    window[callbackFunction] = function (responseText) {
      clearTimeout(timeoutTimer);
      removeScript(head, script);
      ajaxResponse.call(xhrData, 'success', ajaxConvert(responseText, params.dataType));
    };

    script.onerror = function (event) {
      clearTimeout(timeoutTimer);
      removeScript(head, script);
      ajaxResponse.call(xhrData, 'error', 'error', event);
    };

    script.onabort = scriptAbort; // 超时方法

    if (async && timeout > 0) {
      timeoutTimer = window.setTimeout(function () {
        window[callbackFunction] = function () {};

        removeScript(head, script);
        ajaxResponse.call(xhrData, 'error', 'timeout');
      }, timeout);
    }

    script.src = url;
    script.async = async;

    if (params.scriptCharset) {
      script.charset = params.scriptCharset;
    }

    if (typeof params.beforeSend == "function" && params.beforeSend.call(xhrData, script, params.data) === false) {
      return scriptAbort();
    }

    head.appendChild(script);
  }

  xhrData.xhr = xmlhttp;
  return xhrData;
}

export { extend, traditionalData, add_url_query };
window.sjax = ajax;
export default ajax;